import React from 'react'
import moment from 'moment'
import OperacionesCpe from '../OperacionesCpe'
import TableValueAction from '../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../../Camiones/containers/busquedaCpa/InfoCpa'

export const COLUMNS_CAMIONES_SIN_DEFINITIVA = [
  {
    name: 'numero',
    label: 'Carta de porte',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            { numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'fechaDeIngreso',
    label: 'Fecha de ingreso',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (value) => value ? <>{moment(value).format('DD-MM HH:mm')}</> : <>null</>
    }
  },
  {
    name: 'fechaDeCalado',
    label: 'Fecha de calado',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (value) => value ? <>{moment(value).format('DD-MM HH:mm')}</> : <>null</>
    }
  },
  {
    name: 'fechaDeDestare',
    label: 'Fecha de destare',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: (value) => value ? <>{moment(value).format('DD-MM HH:mm')}</> : <>null</>
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'camion',
    label: 'Camión',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'pesoNeto',
    label: 'Neto origen',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return <>{neto} kg.</>
      }
    }
  },
  {
    name: 'ceaPesoNeto',
    label: 'Neto descargado',
    options: {
      filter: false,
      sort: true,
      total: true,
      customBodyRender: (neto) => {
        return <>{neto} kg.</>
      }
    }
  },
  {
    name: 'estadoCtg',
    label: 'Estado CTG',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => value !== 'V'
        ? <><strong style={{ color: '#8e1a05de' }}> Sin confirmar </strong> </>
        : <><strong style={{ color: '#023a1ade' }}> Arribo </strong> </>
    }
  },
  {
    name: 'numero',
    label: ' ',
    options: {
      filter: true,
      sort: true,
      viewColumns: false,
      customBodyRender: value => {
        return <OperacionesCpe numero={value} />
      }
    }
  }
]
export const COLUMNS_CAMIONES_SIN_DEFINITIVA_TO_PRINT = [
  {
    name: 'numero',
    label: 'Carta Porte',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal Variedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeIngreso',
    label: 'Fecha de Ingreso',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de Cupo',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'razonSocialTitular',
    label: 'Titular CPE',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'corredorVendedor',
    label: 'Corredor Vta. Sec.',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'camion',
    label: 'Camión',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'vendedor',
    label: 'Entregador',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNeto',
    label: 'Peso Neto [Kgs]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'turnoDeSalida',
    label: 'Turno Salida',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'estadoCtg',
    label: 'Estado CTG',
    width: 60,
    mantenerCase: true
  }
]
